export default {"src":"/_next/static/media/logo-sanitetskvinnene.5f9fff83.svg","height":65,"width":335,"blurWidth":0,"blurHeight":0};